import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Attribution } from '../models/Attribution';
import { LotMarche } from '../models/LotMarche';
@Component({
  selector: 'app-attribution',
  templateUrl: './attribution.component.html'
})
export class AttributionComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Attribution'
  @Input() parentForm: FormGroup;
  	@Input() attribution : Attribution;

  constructor() { }

  public ngOnInit() {
  }


  addlotMarche(){
		this.attribution.lotMarche.push(new LotMarche());
	}

  removelotMarche(i){
		this.attribution.lotMarche.splice(i, 1);
	}



  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

